import { BaseAnalyticsFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { UtilizationMetrics } from './UtilizationMetrics';
import { UserTrendsCard } from './UserTrendsCard';
import { TopUsersCard } from './TopUsersCard';
import { AnalyticsDashboard } from '../shared/AnalyticsDashboard';

interface UtilizationDashboardProps {
  filters: BaseAnalyticsFilter;
  className?: string;
}

export default function UtilizationDashboard({
  filters,
  className = '',
}: UtilizationDashboardProps) {
  return (
    <AnalyticsDashboard
      filters={filters}
      metricsComponent={UtilizationMetrics}
      cards={[UserTrendsCard, TopUsersCard]}
      spacing="tight"
      className={className}
    />
  );
}
